export default {
  state: {
    isOpen: true,
  },
  mutations: {
    setIsOpen(state, isOpen) {
      state.isOpen = isOpen;
    },
  },
  actions: {
    updateCableOpenStatus(context, isOpen) {
      context.commit("setIsOpen", isOpen);
    },
  },
};
